<template>
  <div class="case">
    <top-nav></top-nav>
    <banner  :bgImage="bgImage"></banner>

    <div class="aboutReyzarBox">
      <ul class="clientCaseBox clearfix">
        <li @mouseenter="item.showMask = true" @mouseleave="item.showMask = false" v-for="(item,index) in caseArr" :key="'case'+index" @click="toDetail(item.url)">
          <a>
            <img :src="item.img" />            
            <div class="clientCaseTit" v-show="!item.showMask">{{item.title}}</div>
            <transition name="slide-fade">
            <div class="clientCaseIn" v-show="item.showMask">
              <div class="clientCaseConn">
                <!-- <div class="clientCaseMain">新互联网时代，<br />即将到来</div> -->
                <div class="clientCaseTit2">{{item.more}} </div>
                <div class="clientCaseMore">了解更多>></div>
              </div>
            </div>
            </transition>
          </a>
        </li>
       
      </ul>
    </div>

    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "case",
  data() {
    return {
      bgImage:'../../../static/images/clientCaseBanner.jpg?011801',
      showMask: false,
      caseArr: [
        {
          title: '智慧政务案例',
          more: '构建智慧政务',
          img: '../../../static/images/clientCasePic01.jpg',
          showMask: false,
          url:'/caseDetail1',
        },
        {
          title: '智慧交通案例',
          more: '构建智慧交通',
          img: '../../../static/images/clientCasePic02.jpg',
          showMask: false,
          url:'/caseDetail2',
        },
        {
          title: '平安城市案例',
          more: '构建平安城市',
          img: '../../../static/images/clientCasePic03.jpg',
          showMask: false,
          url:'/caseDetail3',
        },
        {
          title: '智慧教育案例',
          more: '构建智慧教育',
          img: '../../../static/images/clientCasePic04.jpg',
          showMask: false,
          url:'/caseDetail4',
        },
        {
          title: '多维服务方案案例',
          more: '构建多维服务方案',
          img: '../../../static/images/clientCasePic05.jpg',
          showMask: false,
          url:'/caseDetail5',
        },        
      ],
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {
    toDetail(url){
      this.$router.push({path: url})
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
.case {
  .aboutReyzarBox {
    width: 1200px;
    height: auto;
    padding: 95px 0;
    margin: 0 auto;
    color: #818181;
    li {
      float: left;
      margin-bottom: 20px;
      position: relative;
      img {
        width: 100%;
        display: block;
      }
      .clientCaseTit {
        width: 100%;
        line-height: 30px;
        font-size: 30px;
        color: #fff;
        padding: 30px;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .clientCaseIn {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        left: 0;
        top: 0;
        text-align: left;
        .clientCaseConn {
          width: 100%;
          height: auto;
          padding: 0 30px;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          .clientCaseMain {
            width: 100%;
            line-height: 48px;
            font-size: 40px;
            color: #fff;
            padding-bottom: 20px;
          }
          .clientCaseTit2{
            width: 100%;
            line-height: 60px;
            font-size: 40px;
            color: #fff;
          }
          .clientCaseMore {
            width: 100%;
            line-height: 60px;
            font-size: 30px;
            color: #fff;
          }
        }
      }
      &:nth-of-type(even) {
        margin-left: 20px;
      }
    }
  }
 
}
</style>



// WEBPACK FOOTER //
// src/pages/case/case.vue